export default __webpack_public_path__ + "static/media/portfolio.c34b644a.svg";